import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouterConstants } from './constants/router.constants';
import { LayoutContainerComponent } from './core/layout-container/layout-container.component';
import { AdminGuardService } from './services/admin-guard.service';
import { AuthGuardService } from './services/auth-guard.service';

const routes: Routes = [
  { path: RouterConstants.default, redirectTo: '/' + RouterConstants.layoutContainer + '/' + RouterConstants.dashboard, pathMatch: 'full' },
  { path: RouterConstants.auth, loadChildren: () => import('./auth/auth.module').then(mod => mod.AuthModule) },
  {
    path: RouterConstants.layoutContainer, component: LayoutContainerComponent, canActivate: [AuthGuardService],
    children: [
      { path: RouterConstants.default, redirectTo: RouterConstants.dashboard, pathMatch: "full" },
      { path: RouterConstants.dashboard, loadChildren: () => import('./core/dashboard/dashboard.module').then((mod) => mod.DashboardModule) },
      { path: RouterConstants.tickets.baseUrl, loadChildren: () => import('./core/tickets/tickets.module').then((mod) => mod.TicketsModule) },
      { path: RouterConstants.solutions.baseUrl, loadChildren: () => import('./core/solutions/solutions.module').then((mod) => mod.SolutionsModule) },
      { path: RouterConstants.reports.baseUrl, loadChildren: () => import('./core/reports/reports.module').then((mod) => mod.ReportsModule) },
      { path: RouterConstants.setup.baseUrl, loadChildren: () => import('./core/setup/setup.module').then((mod) => mod.SetupModule) },
      { path: RouterConstants.userProfile.baseUrl, loadChildren: () => import('./core/user-profile/user-profile.module').then((mod) => mod.UserProfileModule) }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
